import { Badge, Group, Stack, Text, Tooltip } from '@mantine/core';
import { IconExclamationCircle, IconPlayerPause, IconWallet } from '@tabler/icons-react';
import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import dayjs from 'dayjs';
import { tKeys, useTranslation } from 'locales';

export const ClientStatusBadges = ({ onPaymentPlanClick }: { onPaymentPlanClick: () => void }) => {
  const { t } = useTranslation();
  const debtor = useDebtor();

  const badges = [
    {
      condition: debtor.has_payment_plan,
      label: t(tKeys.PAYMENT_PLAN.TITLE.ONE),
      tooltip: t(tKeys.ONGOING_PAYMENT_PLAN),
      icon: <IconWallet size={18} stroke={1.5} />,
      badgeBg: 'warning.1',
      badgeC: 'warning.6',
      onClick: onPaymentPlanClick,
    },
    {
      condition: debtor.disputed,
      label: t(tKeys.CLIENT.STATUS.DISPUTE),
      tooltip: `${t(tKeys.REASON)}: ${debtor.reason}`,
      icon: <IconExclamationCircle size={18} stroke={1.5} />,
      badgeBg: 'error.1',
      badgeC: 'error.7',
    },
    {
      condition: debtor.paused,
      label: t(tKeys.CLIENT.STATUS.PAUSED),
      tooltip: (
        <Stack gap={0}>
          <Text>
            {t(tKeys.REASON)}: {debtor.reason}
          </Text>
          {debtor.end_pause_at && (
            <Text>
              {t(tKeys.END_OF_PAUSE)}: {dayjs(debtor.end_pause_at).format('L')}
            </Text>
          )}
        </Stack>
      ),
      icon: <IconPlayerPause size={18} stroke={1.5} />,
      badgeBg: 'purple.1',
      badgeC: 'purple.6',
    },
  ];

  return (
    <Group gap={4}>
      {badges
        .filter(b => b.condition)
        .map(({ label, tooltip, icon, badgeBg, badgeC, onClick }) => (
          <Tooltip label={tooltip} key={label} withArrow>
            <Badge
              styles={{
                label: { fontWeight: 400, textTransform: 'none', fontSize: 14 },
                root: onClick ? { cursor: 'pointer' } : {},
              }}
              leftSection={icon}
              bg={badgeBg}
              c={badgeC}
              radius={6}
              onClick={onClick}
            >
              {label}
            </Badge>
          </Tooltip>
        ))}
    </Group>
  );
};
